export const withCropperCorsCacheBust = (imageSrc: string): string => {
  if (!/^https?:\/\//i.test(imageSrc)) return imageSrc;

  try {
    const url = new URL(imageSrc);
    if (!url.searchParams.has('pe_crop')) {
      url.searchParams.set('pe_crop', '1');
    }
    return url.toString();
  } catch {
    return imageSrc;
  }
};
